<template>
  <div>
    <div class="row pt-3">
      <div class="col-md-12">
        <div class="filter-container">
          <ValidationObserver
            ref="formValidator"
            v-slot="{}"
            tag="form"
            class="row pl-3 pr-1"
          >
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-3 py-1">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="AcademicYear"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="Filter.AcademicYear"
                      :options="academicYears"
                      placeholder="Seleccione el año"
                      required
                      :fieldkey="'id'"
                      :fieldname="'description'"
                      :error="errors[0]"
                      :custom-error-msg="errorMessage.academicYear"
                      :clearable="false"
                      @input="changeAcademicDateLimit"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-7 py-1">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Sie"
                    rules="required"
                  >
                    <custom-input
                      v-model="Filter.Sie"
                      placeholder="Escriba Número de SIE"
                      left-icon
                      icon="fa fa-search orange-icon"
                      :error="errors[0]"
                      :custom-error-msg.sync="errorMessage.sie"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-2 py-1">
                  <action-button
                    text="Buscar"
                    variant="success"
                    class="fr px-4"
                    @click="getModifyStartDateServices"
                  />
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-12">
        <custom-separator text="Modificar Fecha Inicio de Servicio" />
      </div>
    </div>
    <ValidationObserver ref="formValidatorRows" v-slot="{}" tag="form" class="">
      <ValidationProvider
        :value="items"
        :rules="{ atLeastOneDate: items }"
        v-slot="{ errors }"
        name="rows"
      >
        <!-- you can show the error somewhere -->
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
      <div class="row pt-2">
        <div class="col-12">
          <row
            v-for="(item, index) in items"
            :key="`row-item-${index}`"
            :item="item"
            :date-limits="{
              academicDateFromLimit,
              academicDateToLimit,
            }"
          />
        </div>
      </div>
    </ValidationObserver>

    <div class="row pt-4">
      <div class="col-12">
        <customPager
          ref="historyPager"
          :per-page="tableConfig.serverParams.perPage"
          :total="tableConfig.totalRecords"
          :page-changed="onPageChange"
          :per-page-changed="onPerPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import CustomInput from '@/components/common/CustomInput';
import ActionButton from '@/components/common/ActionButton';
import CustomSeparator from '@/components/common/CustomSeparator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import Row from '@/components/pei/transportationServices/components/RowModifyStartDateServices';
import academicYearService from "@/services/academicyear";

export default {
  name: 'ModifyStartDateServices',
  mixins: [mixAlert, mixWait],
  components: {
    CustomInput,
    ActionButton,
    CustomSeparator,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
    Row,
  },
  data() {
    return {
      advance: false,
      Filter: {
        Sie: null,
        Service: null,
        AcademicYear: null,
      },
      pei: null,
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          page: 1,
          perPage: 20,
        },
      },
      academicYears: [],
      academicDateFromLimit: null,
      academicDateToLimit: null,
      items: [],
      Services: [],
      validationMessages: [],
      errorMessage: {
        academicYear: '',
        sie: '',
      },
    };
  },
  methods: {
    changeAcademicDateLimit(academicYear) {
      const selectedAcademicYear = this.academicYears.find(x => x.id === academicYear.id);
      if (selectedAcademicYear) {
        this.academicDateFromLimit = new Date(selectedAcademicYear.fromDate);
        this.academicDateToLimit = new Date(selectedAcademicYear.toDate);
      }
    },
    loadAcademicYears() {
      academicYearService.getAcademicYearsToCurrentYear()
        .then((response) => {
          //Año actual por defecto
          if (response.data.length > 0) {
            this.academicYears = response.data;
            this.Filter.AcademicYear = {
              id: response.data[0].id,
              description: response.data[0].description,
            };
            this.changeAcademicDateLimit(this.Filter.AcademicYear);
          }
        })
        .catch((errm) => {
          this.ShowToast(errm.message, '', 'error');
        });
    },
    loadValidationMessages() {
      const messageCodes = ['18018', '22131', 'R03200148', 'R03200149', '0636'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
        this.errorMessage.academicYear = this.getMessage('18018').name;
        this.errorMessage.sie = this.getMessage('22131').name.replace(
          '{0}',
          'SIE  para poder realizar la búsqueda'
        );
      });
    },
    getHistory() {
      const model = {
        academicYear: this.Filter.AcademicYear.id,
        studentSieId: +this.Filter.Sie,
        pageSize: this.tableConfig.serverParams.perPage,
        pageIndex: this.tableConfig.serverParams.page,
      };

      this.$ApiGet('/api/pei/analysisservice/startdate', model)
        .then((res) => {
          this.items = res.data.data ? this.formatData(res.data.data) : [];
          this.tableConfig.totalPages = res.data.pageCount;
          this.tableConfig.totalRecords = res.data.totalItemCount;
          this.$emit('onChange');
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async onSave() {
      const isValid = this.items.some(x => x.serviceAnalysisPlacementStartDateEdited);

      if (!isValid) {
        this.ShowToast('Error', 'Debe modificar al menos una fecha de inicio.', 'error');
        return;
      }

      const model = this.formatSaveData(this.items);
      this.$ApiPost('/api/pei/analysisservice/startdate', model)
        .then(() => {
          this.ShowToast(
            'Proceso exitoso',
            this.getMessage('0636').name,
            'success'
          );
          this.getHistory();
          this.$refs.formValidatorRows.reset();
        })
        .catch((err) => {
          this.response = err;
        });
    },
    formatData(data) {
      const rows = [];

      data.forEach((element) => {
        const row = {
          peiId: element.peiId,
          studentSieId: element.studentSieId,
          serviceAnalysisPlacementStartDate: element.serviceAnalysisPlacementStartDate,
          generalClosedDate: element.generalClosedDate,
          serviceAnalysisPlacementStartDateEdited: null,
        };
        rows.push(row);
      });
      return rows;
    },
    formatSaveData(data) {
      const rows = [];

      data.forEach((element) => {
        const row = {
          peiId: element.peiId,
          serviceAnalysisPlacementStartDateEdited:
            element.serviceAnalysisPlacementStartDateEdited ?? element.serviceAnalysisPlacementStartDate,
        };
        rows.push(row);
      });
      return rows;
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    //ECG:Table methods
    updateParams(newProps) {
      this.tableConfig.serverParams = Object.assign(
        {},
        this.tableConfig.serverParams,
        newProps
      );
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getHistory();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.getHistory();
    },
    async LoadAlls() {
      let self = this;
      await self.loadAcademicYears();
    },
    async validate() {
      return await this.$refs.formValidator.validate();
    },
    async getModifyStartDateServices() {
      this.items = [];
      this.$emit('onChange');
      let isValid = await this.validate();

      if (isNaN(this.Filter.Sie)) {
        this.Filter.Sie = null;
        isValid = false;
      }

      if (!isValid) {
        this.ShowToast('Error', this.getMessage('R03200148').name, 'error');
        return;
      }

      this.getHistory();
    },
  },
  created() {
    this.loadValidationMessages();
  },
  mounted() {
    this.LoadAlls();
  },
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
</style>
